"use client";

import { Menu, X } from "lucide-react";
import { useSearchParams } from "next/navigation";
import { useState } from "react";

import { marketingConfig } from "@/config/marketing";
import { Link } from "@/lib/i18n";
import { cn } from "@/lib/utils";
import * as m from "@/paraglide/messages";
import { useAppSelector } from "@/services/hooks/redux.hooks";

import LogoText from "../global/LogoText";
import { Icons } from "../shared/icons";
import { buttonVariants } from "../ui/button";

export function NavMobile() {
  const { user_id } = useAppSelector((state) => state.user);

  const [open, setOpen] = useState(false);
  const links = marketingConfig(m).mainNav;
  const searchParam = useSearchParams();
  const redirectTo = searchParam.get("redirect");

  // // prevent body scroll when modal is open
  // useEffect(() => {
  //   if (open) {
  //     document.body.style.overflow = "hidden";
  //   } else {
  //     document.body.style.overflow = "auto";
  //   }
  // }, [open]);

  return (
    <>
      <button
        onClick={() => setOpen(!open)}
        className="absolute right-2 bottom-2.5 z-50 rounded-full p-2 transition-colors duration-200 hover:bg-muted focus:outline-none active:bg-muted lg:hidden"
      >
        <Menu className="size-5 text-muted-foreground" />
      </button>

      <nav
        className={cn(
          "fixed inset-0 z-[100] hidden w-full overflow-auto bg-background px-5 pb-16 pt-4 lg:hidden",
          open && "block",
        )}
      >
        <div className="items-center flex justify-between flex-row mb-4">
          {open && <LogoText className="h-7" />}

          <button onClick={() => setOpen(!open)}>
            <X className="size-5 text-muted-foreground" />
          </button>
        </div>

        <ul className="grid divide-y divide-muted">
          {links.map(({ title, href }: { title: string; href: string }) => (
            <li key={href} className="py-3">
              <Link
                href={href}
                onClick={() => setOpen(false)}
                className="flex w-full font-medium capitalize"
              >
                {title}
              </Link>
            </li>
          ))}

          <li className="py-3">
            {!user_id ? (
              <Link
                className={cn(
                  buttonVariants({ variant: "default", size: "sm" }),
                  " gap-2 px-4 w-full",
                )}
                href={
                  redirectTo != null
                    ? `/signin?redirect=${redirectTo}`
                    : "/signin"
                }
              >
                <span>{m.sign_in()}</span>
                <Icons.arrowRight className="size-4" />
              </Link>
            ) : (
              <Link
                className={cn(
                  buttonVariants({ variant: "default", size: "sm" }),
                  " gap-2 px-4  w-full",
                )}
                href="/dashboard"
              >
                <span className="normal-case">{m.dashboard()}</span>
                <Icons.arrowRight className="size-4" />
              </Link>
            )}
          </li>
        </ul>
      </nav>
    </>
  );
}
